module.exports = __webpack_public_path__ + "static/media/Level_6.3ee8fd3d.png";